var _defs, _rect, _path, _path2, _path3, _path4, _path5, _path6, _path7, _circle, _circle2, _path8, _path9, _path0, _path1, _line, _line2, _path10, _rect2, _path11, _rect3, _polygon, _polygon2, _rect4, _rect5, _path12, _path13, _polygon3, _polygon4, _polygon5, _path14, _path15, _line3, _text, _path16, _path17, _g, _path18, _path19, _g2, _g3, _rect6, _rect7, _g4, _circle3, _circle4, _g5, _path20, _path21, _path22, _path23, _path24, _g6, _g7, _path25, _line4, _line5, _line6, _line7, _line8, _line9, _line0, _line1, _g8, _path26, _path27, _path28, _path29, _path30;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPackagingdesignproductiontab(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 765 277",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1,.cls-15,.cls-16,.cls-23,.cls-28,.cls-31,.cls-6,.cls-8,.cls-9{fill:none;}.cls-2{fill:#d8c4df;}.cls-3{fill:#e5aa80;}.cls-4{fill:#9a499c;}.cls-5{fill:#263238;}.cls-6{stroke:#263238;stroke-linecap:round;stroke-width:1.16px;}.cls-15,.cls-16,.cls-23,.cls-28,.cls-31,.cls-6,.cls-8,.cls-9{stroke-miterlimit:10;}.cls-7{fill:#e8996f;}.cls-8{stroke:#303030;}.cls-8,.cls-9{stroke-width:0.58px;}.cls-9{stroke:#e8996f;}.cls-10,.cls-17{fill:#2f2143;}.cls-11{fill:#713875;}.cls-12{fill:#a7bdc6;}.cls-13{fill:#e6e6e6;}.cls-14{fill:#fdc435;}.cls-15{stroke:#c5d3d8;}.cls-15,.cls-16{stroke-width:0.68px;}.cls-16{stroke:#a7bdc6;}.cls-17{font-size:35px;font-family:CenturyGothic-Bold, Century Gothic;font-weight:700;}.cls-18{opacity:0.8;}.cls-19{clip-path:url(#clip-path);}.cls-20{clip-path:url(#clip-path-2);}.cls-21{clip-path:url(#clip-path-3);}.cls-22{clip-path:url(#clip-path-4);}.cls-23{stroke:#9a499c;stroke-width:1.49px;}.cls-24{opacity:0.5;}.cls-25{clip-path:url(#clip-path-5);}.cls-26{fill:#f2d686;}.cls-27{fill:#2e1f42;}.cls-28{stroke:#4f4e4f;stroke-width:0.67px;}.cls-29{clip-path:url(#clip-path-6);}.cls-30{clip-path:url(#clip-path-7);}.cls-31{stroke:#2e1f42;stroke-width:0.95px;}.cls-32{clip-path:url(#clip-path-8);}.cls-33{fill:#fff;}.cls-34{fill:#293b4a;}"), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 679.2,
    y: 83.76,
    width: 28.9,
    height: 24.94,
    transform: "translate(-2.21 174.93) rotate(-14.35)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-2"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 653.47,
    y: 36.69,
    width: 16.63,
    height: 54.05,
    transform: "translate(4.86 166.02) rotate(-14.35)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-3"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 697.56,
    y: 25.31,
    width: 16.71,
    height: 54.07,
    transform: "translate(9.05 176.6) rotate(-14.35)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-4"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 620.52,
    y: 46.61,
    width: 5.03,
    height: 54.07,
    transform: "translate(1.19 156.72) rotate(-14.35)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-5"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 188.74,
    y: 27.14,
    width: 27.92,
    height: 31.62,
    transform: "translate(0.41 87.82) rotate(-24.47)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-6"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 189.38,
    y: 33.05,
    width: 6.8,
    height: 6.39,
    transform: "translate(2.3 83.11) rotate(-24.47)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-7"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 188.17,
    y: 32.11,
    width: 9.54,
    height: 8.96,
    transform: "translate(2.17 83.2) rotate(-24.47)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-8"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 654.85,
    y: 204.45,
    width: 49.35,
    height: 49.27
  })))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "packaging design &amp;amp; production tab") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    width: 765,
    height: 277
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M151.54,207.82l2.19,7L179,192.49l10.62-13.12,6.27-2.58-3,5.26a39,39,0,0,0,5.35-1.25c7.39-2.3,11.29-6,12.55-4.9.83.73-.05,3-.53,4.19-1.48,3.54-5.14,10.42-15,19.14l-6.13,1.6S170.88,229.71,165,234.35c0,0-7.16,9.63-14.22,10,0,0-19.4,2.67-23.43-16.11,0,0-2.23-13.31-1.17-13.6Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M134.42,277s-9.14-58.61-8.31-61.57L153.64,208s-9.35-42.61-27.24-49.62c0,0-30.21-4.59-35.63-4.58l1.78,4.27-7.82,16.52L60.5,168.32l-3.29-9.54L31,174s-4.25.81-5.87,9.64l-8.43,32.38,23.39-.76s10.19,24.76,9.35,32.13L47.37,277Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M60.94,169.66l24.13,5.72,7.92-16-2.44-7A15.83,15.83,0,0,0,99.2,136s-12.36-34.7-16.39-37.77-39.05-13-39.51,9.11l3.91,24.3s-6.51,1.35-5,7,5,8.15,10.17,5.9Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M18,216l20.63-.64-.28,3.44S79.35,179.73,80,178H94.27L103.41,190a10.57,10.57,0,0,1-4.47-.37s-1,0-3.43-4c0,0,1.79,4,1.2,5.68a38.83,38.83,0,0,1-1.85,4.56S93.72,198.7,93,199s-.6.55-3,0c0,0-3.07-.88-3.57-2.45a1.21,1.21,0,0,1,.87-1.49l-3.74-.59s-4.07,7-5.54,8.36c0,0-1.53,2.3-6.76,4.08l-21.4,37.28a45.11,45.11,0,0,1-11.8,13.26l-13.4,8.34s-7-1.43-11.42-5c0,0-3.59-3.14-2.63-15.1C10.63,245.62,15.19,221,18,216Z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M48.36,135.71s5.43-6.71.45-10.37c0,0,5.33-2.33-3.8-15.38,0,0,12.78-6.72,12.21-11,0,0,15.91,6.73,24,.62,0,0,8.06-4.26,5-9,0,0,3.44-14.76-11-10.51,0,0-11.48-5.71-20.23,3.31,0,0-13.33-.79-16.79,10.24,0,0-12.74,9.14-5.26,16.13,0,0-5.31,5.57,3.14,9.12C36.06,118.92,45.09,135.79,48.36,135.71Z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M57.78,117.59s.73-5.9,8.89-3.63"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M76.27,111.17s.73-5.9,8.89-3.63"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "cls-5",
    cx: 66.67,
    cy: 120.73,
    r: 1.85
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    className: "cls-5",
    cx: 83.8,
    cy: 115.29,
    r: 1.85
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M72.87,115.51c1.93,1.67,3.81,3.38,5.65,5.15.91.88,1.85,1.74,2.74,2.65L84,126l.3.29-.41.1c-1.83.45-3.67.91-5.53,1.29,1.79-.63,3.6-1.19,5.41-1.74l-.1.39-2.77-2.63c-.93-.87-1.81-1.79-2.72-2.68Q75.44,118.35,72.87,115.51Z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M70.64,135.71A8.87,8.87,0,0,0,75.12,139a3.61,3.61,0,0,0,.65.15,3.13,3.13,0,0,0,.68.06c.23,0,.46,0,.69,0s.46-.05.69-.06c.48,0,.94-.18,1.43-.25s.94-.27,1.46-.36a14.33,14.33,0,0,1-1.26.9,7.91,7.91,0,0,1-1.44.59,5.83,5.83,0,0,1-3.21.07,5.75,5.75,0,0,1-2.73-1.69A6,6,0,0,1,70.64,135.71Z"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M90.55,152.41s-9,3.54-14.28,0c0,0,4.69,8.1,15.42,4.16Z"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M126.4,158.37s-3.85,6-3.85,18.68"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    className: "cls-8",
    x1: 127,
    y1: 215.03,
    x2: 126.4,
    y2: 189.24
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    className: "cls-8",
    x1: 40.08,
    y1: 215.29,
    x2: 35.3,
    y2: 189.24
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M154.34,214.15s-9.74,1.69-7.93,10.31"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 191.44,
    y: 117.27,
    width: 30.73,
    height: 60.05
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M88.38,178,74.65,149.46s.07-3.63,3.48-1.72L93.31,178Z"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-10",
    x: 181.04,
    y: 130.25,
    width: 30.73,
    height: 60.05
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-11",
    points: "211.77 130.25 222.17 117.27 222.17 177.32 211.77 190.3 211.77 130.25"
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-4",
    points: "211.77 130.25 222.17 117.27 191.44 117.27 181.04 130.25 211.77 130.25"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-12",
    x: 188.19,
    y: 154.44,
    width: 0.9,
    height: 1.51,
    transform: "translate(9.71 321.49) rotate(-82.35)"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-12",
    x: 206.53,
    y: 156.42,
    width: 0.9,
    height: 1.51,
    transform: "translate(42.94 358.76) rotate(-88.07)"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M207.36,146.71a.59.59,0,0,1-.83,0,.59.59,0,0,1,.81-.86.6.6,0,0,1,0,.84"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M186.38,148.64a.56.56,0,1,1,0-.79.56.56,0,0,1,0,.79"
  })), _polygon3 || (_polygon3 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-13",
    points: "204.9 167.02 201.38 173.32 192.88 172.74 190.01 165.76 197.57 148.17 199.73 153.85 204.9 167.02"
  })), _polygon4 || (_polygon4 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-14",
    points: "201.21 176.38 192.16 175.85 192.41 172.51 201.46 173.04 201.21 176.38"
  })), _polygon5 || (_polygon5 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-5",
    points: "197.32 153.04 197.97 153.13 197.44 166.99 196.8 166.91 197.32 153.04"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M198.69,166.54a1.49,1.49,0,0,1-3-.23,1.5,1.5,0,0,1,1.61-1.38h0a1.49,1.49,0,0,1,1.37,1.61"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "M188.64,154.93c1.08-4.46,5.16-7.78,9.43-7.62a9.51,9.51,0,0,1,8.91,9.61"
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    className: "cls-16",
    x1: 186.02,
    y1: 148.25,
    x2: 206.88,
    y2: 146.35
  })), _text || (_text = /*#__PURE__*/React.createElement("text", {
    className: "cls-17",
    transform: "translate(248.02 143.53)"
  }, "PACKAGING DESIGN", /*#__PURE__*/React.createElement("tspan", {
    x: 46.88,
    y: 40
  }, "&amp; PRODUCTION"))), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M705,15.59c-1.51.38-3.12-.69-3.79-3.33l-.57-2.07-7.26,1.86a1.35,1.35,0,0,0-1,1.62,1.33,1.33,0,0,0,1.68.92l2-.51a.13.13,0,0,1,.17.1.14.14,0,0,1-.1.17l-8,2,3,11.83,16.11-4.12Zm-.62,8.15-1,.27-1.29-5-5.19-1.49s-.22,0-.24-.19.15-.18.15-.18l5.55-1.42Z"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M649.32,23.42a1.34,1.34,0,0,0-1,1.62A1.32,1.32,0,0,0,650,26l2-.51a.12.12,0,0,1,.16.1.13.13,0,0,1-.09.17l-4,1c.39,1.51-.68,3.12-3.32,3.8L647,39.6l16.1-4.12L659.4,20.85Zm5,5-3.84,3.79,1.29,5-1,.26-2.06-8,5.55-1.42s.17-.06.23.09-.12.28-.12.28"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "cls-18"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-19"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "M676.56,87.73l4.12,16.12,5.07,7.28,21.7-5.55,1.23-8.89-4.13-16.12Zm20.57,12.67a2.34,2.34,0,0,1-4.53,1.16l-.33-1.26a2.34,2.34,0,0,1,4.54-1.16Z"
  })))), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M660.44,92l2.31,9.06c2.65-.67,4.36.22,4.75,1.73l4-1a.14.14,0,0,1,.17.1.14.14,0,0,1-.1.17l-2,.51a1.32,1.32,0,0,0-1,1.62,1.34,1.34,0,0,0,1.67.92l10.08-2.58-3.74-14.63Zm11.85,6.64L666.73,100,664.67,92l1.05-.27L667,96.76l5.19,1.48s.22,0,.24.19-.15.19-.15.19"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M704.6,80.59l3,11.82,8-2s.13,0,.16.1a.13.13,0,0,1-.1.17l-2,.51a1.33,1.33,0,0,0-1,1.62,1.35,1.35,0,0,0,1.68.92l7.26-1.86-.49-2.08c-.68-2.64.22-4.36,1.73-4.74l-2.17-8.53Zm15.8,5.63-5.56,1.42s-.17,0-.22-.09.12-.29.12-.29l3.84-3.79-1.29-5,1.05-.27Z"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    className: "cls-18"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-20"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-14",
    x: 653.47,
    y: 36.7,
    width: 16.63,
    height: 54.05,
    transform: "translate(4.86 166.02) rotate(-14.35)"
  })))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    className: "cls-18"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-21"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-14",
    x: 697.56,
    y: 25.31,
    width: 16.71,
    height: 54.07,
    transform: "translate(9.05 176.6) rotate(-14.35)"
  })))), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-10",
    x: 669.37,
    y: 30.97,
    width: 28.9,
    height: 54.07,
    transform: "translate(6.96 171.3) rotate(-14.35)"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-10",
    x: 625.01,
    y: 42.38,
    width: 29.14,
    height: 54.07,
    transform: "translate(2.75 160.69) rotate(-14.35)"
  })), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    className: "cls-18"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-22"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-14",
    points: "626.76 98.36 632.17 99.22 618.76 46.83 614.56 50.66 626.76 98.36"
  })))), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    className: "cls-23",
    cx: 423.34,
    cy: 42.64,
    r: 13.18
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    className: "cls-23",
    cx: 267.92,
    cy: 237.9,
    r: 13.18
  })), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    className: "cls-24"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-25"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M214.63,35.49c.54,1.15,2.09,4.44,1.1,7.85-.54,1.86-1.53,2.73-1.84,5.2s.55,3,.13,4.45c-1,3.51-7.18,6.16-10.76,4.46-1.42-.67-1.37-1.53-3.57-2.74s-3.27-1-4.8-1.59c-3.51-1.34-5.2-5-5.67-6.07-2.5-5.49-.85-14.94,6.93-18.48s15.93,1.51,18.48,6.92"
  })))), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    className: "cls-26",
    d: "M214.63,35.49c.54,1.15,2.09,4.44,1.1,7.85-.54,1.86-1.53,2.73-1.84,5.2s.55,3,.13,4.45c-1,3.51-7.18,6.16-10.76,4.46-1.42-.67-1.37-1.53-3.57-2.74s-3.27-1-4.8-1.59c-3.51-1.34-5.2-5-5.67-6.07-2.5-5.49-.85-14.94,6.93-18.48s15.93,1.51,18.48,6.92"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    className: "cls-27",
    d: "M214.12,55.13,205,59.28a1.86,1.86,0,1,1-1.54-3.38l9.11-4.15a1.86,1.86,0,0,1,1.54,3.38"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    className: "cls-27",
    d: "M216.51,59.56l-9.25,4.2a1.78,1.78,0,1,1-1.47-3.24L215,56.31a1.79,1.79,0,0,1,1.48,3.25"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    className: "cls-27",
    d: "M218.4,64.37l-8.75,4a2,2,0,1,1-1.7-3.73l8.75-4a2.05,2.05,0,1,1,1.7,3.74"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    className: "cls-28",
    d: "M206.18,54.67s-2.26-6.87-4.19-8.38-1.81,2.71-.24,2.21a3.9,3.9,0,0,0,2.61-3.38c.22-1.54-2.52-2.4-1.38-.43s3.64.64,4.47.36-1.5-3.72-1.69-1.82.86,2.29,1.79,3.3,3,6.15,3,6.15"
  })), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    className: "cls-24"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-29"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-26",
    d: "M194.43,32.57c1.19.53,1.41,2.61.5,4.64s-2.61,3.25-3.8,2.71-1.4-2.61-.49-4.64,2.61-3.24,3.79-2.71"
  })))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    className: "cls-24"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-30"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-26",
    d: "M195.25,31.43c1.66.75,2,3.66.7,6.51s-3.66,4.55-5.33,3.8-2-3.66-.69-6.5,3.66-4.55,5.32-3.81"
  })))), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    className: "cls-27",
    d: "M218.55,69.28l-4.7,2.14a2.22,2.22,0,0,1-2.93-1.1l-.4-.89a2.21,2.21,0,0,1,1.09-2.93l4.7-2.14a2.21,2.21,0,0,1,2.92,1.1l.41.89a2.21,2.21,0,0,1-1.09,2.93"
  })), _line4 || (_line4 = /*#__PURE__*/React.createElement("line", {
    className: "cls-31",
    x1: 207.58,
    y1: 23.44,
    x2: 210.88,
    y2: 17.62
  })), _line5 || (_line5 = /*#__PURE__*/React.createElement("line", {
    className: "cls-31",
    x1: 197.31,
    y1: 25.51,
    x2: 194.54,
    y2: 19.42
  })), _line6 || (_line6 = /*#__PURE__*/React.createElement("line", {
    className: "cls-31",
    x1: 189.51,
    y1: 30.13,
    x2: 184.25,
    y2: 26
  })), _line7 || (_line7 = /*#__PURE__*/React.createElement("line", {
    className: "cls-31",
    x1: 185.76,
    y1: 38.02,
    x2: 179.1,
    y2: 37.38
  })), _line8 || (_line8 = /*#__PURE__*/React.createElement("line", {
    className: "cls-31",
    x1: 186.46,
    y1: 46.01,
    x2: 180.37,
    y2: 48.78
  })), _line9 || (_line9 = /*#__PURE__*/React.createElement("line", {
    className: "cls-31",
    x1: 190.24,
    y1: 52.67,
    x2: 186.14,
    y2: 57.96
  })), _line0 || (_line0 = /*#__PURE__*/React.createElement("line", {
    className: "cls-31",
    x1: 213.76,
    y1: 30.28,
    x2: 219.95,
    y2: 27.74
  })), _line1 || (_line1 = /*#__PURE__*/React.createElement("line", {
    className: "cls-31",
    x1: 218.36,
    y1: 38.12,
    x2: 225.05,
    y2: 38.16
  })), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    className: "cls-24"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-32"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-33",
    d: "M701.64,253.72H657.42a2.57,2.57,0,0,1-2.57-2.57V207a2.57,2.57,0,0,1,2.57-2.57h44.22a2.57,2.57,0,0,1,2.57,2.57v44.13a2.57,2.57,0,0,1-2.57,2.57"
  })))), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M704.21,210.57H654.85v-3.71a2.4,2.4,0,0,1,2.41-2.41h44.58a2.37,2.37,0,0,1,2.37,2.36Z"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    className: "cls-33",
    d: "M699.11,207.59a1.3,1.3,0,1,1-1.3-1.29,1.3,1.3,0,0,1,1.3,1.29"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    className: "cls-33",
    d: "M695.42,207.54a1.3,1.3,0,1,1-1.29-1.29,1.3,1.3,0,0,1,1.29,1.29"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    className: "cls-33",
    d: "M691.74,207.54a1.3,1.3,0,1,1-1.3-1.29,1.3,1.3,0,0,1,1.3,1.29"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    className: "cls-34",
    d: "M692.23,218.11v7.21h-.71a11.36,11.36,0,0,0-1.39-3.58A5.35,5.35,0,0,0,688,220a6.6,6.6,0,0,0-2.61-.35h-2v20.54a8.55,8.55,0,0,0,.22,2.56,2.05,2.05,0,0,0,.89.89,3.65,3.65,0,0,0,1.8.38h.88v.73h-14V244h.89a3.71,3.71,0,0,0,1.86-.41,1.91,1.91,0,0,0,.81-.94,8.37,8.37,0,0,0,.21-2.48V219.65h-1.92a5.6,5.6,0,0,0-3.91,1.14,7.51,7.51,0,0,0-2.16,4.53h-.75v-7.21Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPackagingdesignproductiontab);
export default __webpack_public_path__ + "static/media/packaging design & production tab.93a6c9e4c02d79f7b5afe27836fabba7.svg";
export { ForwardRef as ReactComponent };